import React from 'react';
import Word from 'saur_ui_library/src/Atoms/Word/Word';

interface SwitchButtonComponentProps {
  buttonIds: string[];
  module?: string;
  buttonNames: string[];
  buttonCallback: (buttonName: string) => void;
  buttonColors: any;
}

const SwitchButtonComponent = (props: SwitchButtonComponentProps) => {
  return (
    <div
      className='sds-reset-style'
      style={{
        marginBottom: '10px',
        display: 'inline-flex',
        borderRadius: '25px',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <div style={{ backgroundColor: '#edf2fa', borderRadius: '25px', display: 'flex' }}>
        {props.buttonIds.map((buttonId, index) => {
          return (
            <button
              key={`${buttonId}-${index}`}
              type='button'
              data-testid='submit-btn'
              id={buttonId}
              style={{
                borderRadius: '40px',
                padding: '12px 25px 14px 25px',
                backgroundColor: props.module !== 'h2s' 
                ? props.buttonColors[index] :  props.buttonColors[buttonId],
              }}
              onClick={() => {
                if (props.buttonCallback) {
                  props.buttonCallback(
                    props.module !== 'h2s'
                      ? props.buttonNames[index]
                      : buttonId,
                  );
                }
              }}
            >
              <span style={{ fontSize: '14px', color: '#232323', fontWeight: 'bolder' }}>{props.buttonNames[index]}</span>
            </button>
          );
        })}      
        </div>
    </div>
  );
};

export default SwitchButtonComponent;
